import { createRoot } from 'react-dom/client'
import './i18n'
import './styles.css'
import { App } from 'components/App'
declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    // Facebook Pixel
    fbq: any
    // ZenDesk plugin
    zE: any
    zESettings: any
    // Google analytics
    gtag: any
    MSStream: any
    // TikTok Pixel
    ttq: any
    // Snap Pixel
    snaptr: any
    // UET Tag Code
    uetq: any
    // Pinterest Tag Code
    pintrk: any
    dataLayer: any
    axon: any
    // Reteno Web Tracking
    eS: any
    // Reteno Web Push SDK
    es: any
    // Cookieyes Tag Code
    cookieyes: any
    getCkyConsent: () => {
      activeLaw: string
      isUserActionCompleted: boolean
    }
  }
}

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
